import { useMemo } from "react";
import { debouncer } from "../utils/utility";

const useDebouncedInputChange = (callback, delay) => {
    return useMemo(() => debouncer(callback, delay), []);
};

export default useDebouncedInputChange;
